import { createSlice } from "@reduxjs/toolkit";

export const headerSlice = createSlice({
  name: "header",
  initialState: {
    isAsideOpen: false,
  },
  reducers: {
    changeAsideStatus: (state, action) => {
      state.isAsideOpen = action.payload;
    },
  },
});

export const { changeAsideStatus } = headerSlice.actions;

export const selectIsAsideOpen = (state) => state.header.isAsideOpen;

export default headerSlice.reducer;
